const metatags = {
  homepage: {
    title: 'LaVilla Boutique Hotel',
    description:
      'LaVilla Boutique Hotel, Mediterranean, Chinese and Sushi Cuisine ',
  },
  restaurant: {
    title: 'Mediterranean, Chinese ans Sushi Cuisine',
    description:
      'Taste exquisite Mediterranean specialities in LaVilla restaurant or travel to the far east with restaurant Shanghai Cuisine',
  },
  offers: {
    title: 'LaVilla special offers and promotions',
    description:
      'Rent a semisubmarine, yacht or a speedboat or just relax on our secluded private beach',
  },
  room: {
    title: 'LaVilla rooms',
    description: 'Enjoy Budva Old Town beauty from one of our lavishing rooms',
  },
};

export default metatags;